import React, { Component } from "react";
import { Button, Form, Row, Col, Image } from "react-bootstrap";
import { SendSmsEmailConext } from "../../provider";
import { toast } from "react-toastify";
import Files from "react-files";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// loader
import { LoaderPage } from "../../../../component/Loader";
// actions
import { sendEmailNotificationAction } from "../../../../actions/sendEmailAndSms.action";
import { removeFileAction } from "../../../../actions/common.action";
// helpers
import { isFunction } from "lodash";
// templates
import { ProjectMessageTemplate } from "../../projectMessageTemplate";
import { IssueMessageTemplate } from "../../issueMessageTemplate";
import { InfoIcon } from "../../../infoIcon";
import IconPin from "../../../../assets/icon-pin.png";
import {
  DOCUMENT_FORMATS,
  FILE_SIZE_LIMIT,
  ERROR_MSG,
  OTHER_FORMATS
} from "../../../../constant";
import { FormDataForImage } from "../../../../helper";
import { getUploadAttachmentApiResponse } from "../../../../container/reusableComponent/helper";
import { successToastStyle, errorToastStyle } from "../../../../customToast";
//
import { UserInfo } from "../usersInfo";
import htmlToFormattedText from "html-to-formatted-text";
//import { CKEditor } from "@ckeditor/ckeditor5-react";
//import Editor from "cms-ckeditor5-react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

// import DOMPurify from "dompurify";
class Template extends Component {
  static contextType = SendSmsEmailConext;

  state = {
    responseFromUploadApi: {},
    attachmentPayload: [],
    toMails: "",
    ccMails: "",
    subject: "",
    message: "",
    isValid: {
      toMails: [],
      ccMails: []
    },
    disabled: false,
    isDataLoaded: false,
    errors: {
      toMails: { error: false, message: "Field is required" },
      subject: { error: false, message: "Field is required" }
    },
    attachedFileId: []
  };

  static getDerivedStateFromProps(props, state) {
    const { toMails, ccMails, subject, message, mailList, disabled } =
      props.templateInfo || {};
    // if form is already submitted
    if (props.templateInfo && disabled) {
      return {
        toMails: "",
        ccMails: "",
        subject: "",
        message: "",
        mailList: [],
        disabled
      };
    }
    // if mails data is empty then do this
    if (props.templateInfo && !state.isDataLoaded && !state.toMails) {
      return {
        toMails,
        ccMails,
        subject,
        message,
        mailList,
        isDataLoaded: true,
        disabled
      };
    }
    return null;
  }

  onKeyDown = e => {
    const { which } = e;
    const {
      dataset: { title }
    } = e ? e.target : {};
    if (
      !(which === 8) &&
      !(which === 46) &&
      !(which === 37) &&
      !(which === 39)
    ) {
      e.preventDefault();
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          [title]: {
            error: true
          }
        }
      }));
    }
  };

  onChange = e => {
    const {
      value,
      dataset: { title }
    } = e.target;
    this.setState(prevState => ({
      [title]: value,
      errors: {
        ...prevState.errors,
        [title]: {
          error: !value,
          message: !value ? "Field is required" : ""
        }
      }
    }));
    //this.setState({ toMails: 'charpe.jayshri@gmail.com' });
  };

  onBlur = e => {
    const {
      value,
      dataset: { title }
    } = e.target;
    const { toMails } = this.props.templateInfo;
    const currentVal =
      title === "toMails"
        ? this.removeEmailsIds(toMails, value)
        : title === "ccMails"
        ? this.onValidateEmail(value)
        : value;
    this.setState(prevState => ({
      [title]: currentVal,
      errors: {
        ...prevState.errors,
        [title]: {
          error: !value,
          message: !value ? "Field is required" : ""
        }
      }
    }));
  };

  removeEmailsIds = (oldData, newData) => {
    const newDataArray = newData.split(",");
    let index = 0,
      arr = [];
    for (; index <= newDataArray.length - 1; index++) {
      const currentValue = newDataArray[index];
      if (oldData.includes(currentValue)) {
        arr.push(currentValue);
      }
    }
    return arr;
  };

  onValidateEmail = emailsArr => {
    const newDataArray = emailsArr.split(",");
    let index = 0,
      arr = [];
    for (; index <= newDataArray.length - 1; index++) {
      if (
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
          newDataArray[index].trim()
        )
      ) {
        arr.push(newDataArray[index].trim());
      }
    }
    return arr.join(",");
  };

  onSubmit = () => {
    const {
      toMails,
      ccMails,
      subject,
      message,
      responseFromUploadApi,
      attachedFileId
    } = this.state;
    const isValid = toMails && subject;
    const { userNotificationType, tabIndex, meetingId } = this.props;
    const {
      customNotificationType,
      onSubmitClearData,
      notificationCO
    } = this.context;
    let attachments = [];
    if (Object.keys(responseFromUploadApi).length !== 0) {
      attachments = attachedFileId.map(attachment => attachment[0].data.id);
    }
    if (isValid) {
      const params = {
        meetingId,
        ...notificationCO,
        ...{ sendBy: "template/email" },
        userNotificationType,
        customNotificationType,
        to: toMails,
        cc: typeof ccMails === "string" ? ccMails.split(",") : ccMails,
        subject: htmlToFormattedText(subject),
        //message: htmlToFormattedText(message),
        message: message,
        attachments
      };
      this.setState(
        {
          isLoading: true
        },
        async () => {
          const response = await sendEmailNotificationAction(undefined, params);
          const { data } = response;
          const { status, message } = data || {};
          const state = status
            ? { toMails: "", ccMails: "", subject: "", message: "" }
            : {};
          status &&
            isFunction(onSubmitClearData) &&
            onSubmitClearData(+tabIndex);
          this.setState(
            { isLoading: false, ...state, responseFromUploadApi: {} },
            () => {
              status
                ? toast.success(
                    <p className="toast-text-alignment">{message}</p>,
                    successToastStyle
                  )
                : toast.error(message);
            }
          );
        }
      );
    } else {
      this.setState(prevState => ({
        errors: {
          toMails: {
            error: !prevState.toMails,
            message: !prevState.toMails ? "Field is required" : ""
          },
          subject: {
            error: !prevState.subject,
            message: !prevState.subject ? "Field is required" : ""
          }
        }
      }));
    }
  };

  onToggleUserInfo = () => {
    this.setState(prevState => ({
      displayUserInfo: !prevState.displayUserInfo
    }));
  };
  uploadAttachmentApiCallback = http => {
    var responseFromUploadApi = {};
    // checking readyState === 4 which means that the request
    // had been sent, the server had finished returning the response and
    // the browser had finished downloading the response content.
    if (http.readyState === 4 && http.status === 200) {
      responseFromUploadApi = http.response;

      this.setState({
        responseFromUploadApi: JSON.parse(responseFromUploadApi),
        isLoading: false
      });
      if (Object.keys(responseFromUploadApi).length !== 0) {
        this.setState({
          attachedFileId: [
            ...this.state.attachedFileId,
            [JSON.parse(responseFromUploadApi)]
          ]
        });
      }
    }
  };
  onAttachment = e => {
    if (e.length === 0) {
      toast.error(
        <p className="toast-text-alignment">File type not supported</p>,
        errorToastStyle
      );
    } else {
      delete e[0].preview;
      delete e[0].sizeReadable;
      e[0].toggleEdit = true;
      e[0].title = "";
      this.setState(
        { attachmentPayload: [...this.state.attachmentPayload, e[0]] },
        () => {
          this.onFileUpload();
        }
      );
    }
  };
  onFileUpload = () => {
    const { attachmentPayload, responseFromUploadApi } = this.state;
    let attachments = attachmentPayload.slice(-1);
    if (attachments.length !== 0) {
      if (attachments[0].size > FILE_SIZE_LIMIT.EMAIL_ATTACHMENT) {
        toast.error(
          <p className="toast-text-alignment">
            The file exceeds the maximum size limit of 10 MB
          </p>,
          errorToastStyle
        );
      } else {
        attachments = FormDataForImage(attachments, "file");
        getUploadAttachmentApiResponse(
          attachments,
          undefined,
          this.uploadAttachmentApiCallback
        );
        if (Object.keys(responseFromUploadApi).length === 0) {
          this.setState({ isLoading: true });
        }
        if (attachmentPayload.length > 1) {
          this.setState({ isLoading: true });
        }
      }
    }
  };
  removeFileAttachment = async (file, index) => {
    const { removeFileDispatch } = this.props;
    const { attachedFileId } = this.state;
    try {
      const response = await removeFileDispatch(undefined, {
        fid: file.id
      });
      if (response) {
        const { status, message } = response;
        if (status) {
          attachedFileId.splice(index, 1);
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          this.setState({ attachedFileId });
        } else {
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        }
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };

  handleChange(html, event) {
    console.log(html, event);
    this.setState({ message: html });
  }

  render() {
    const {
      onChange,
      onBlur,
      onKeyDown,
      onSubmit,
      onToggleUserInfo,
      onAttachment
    } = this;
    const {
      toMails,
      ccMails,
      subject,
      message,
      disabled,
      isLoading,
      mailList,
      displayUserInfo,
      errors,
      responseFromUploadApi,
      attachedFileId
    } = this.state;
    const { customNotificationType } = this.context;

    const toolbarConfig = {
      toolbar: [
        ["bold", "italic", "underline", "strike"],
        [
          { header: "1" },
          { header: "2" }
          // { font: [] }
        ],
        [{ size: [] }],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" }
        ]
        // ["clean"],
      ]
    };
    const formats = [
      "header",
      "font",
      "size",
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "list",
      "bullet",
      "indent",
      "link",
      "image",
      "video"
    ];

    return (
      <>
        <LoaderPage loading={isLoading} />
        {displayUserInfo ? (
          <UserInfo
            options={mailList}
            titles={["Name", "Email"]}
            onCloseModal={onToggleUserInfo}
          />
        ) : null}
        <Row noGutters={true}>
          <Col>
            <Form.Group controlId="to">
              <Form.Label id="to">
                TO <span className="required">*</span>
                <Button
                  size="sm"
                  variant="outline-info"
                  onClick={onToggleUserInfo}
                >
                  Users Info
                </Button>
              </Form.Label>
              <Form.Control
                rows="3"
                value={toMails}
                type="text"
                data-title="toMails"
                onChange={onChange}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                disabled={disabled}
                isInvalid={!!errors.toMails.error}
              />
              <Form.Control.Feedback type="invalid">
                <p>
                  Note: Additional email address can not be added. But, existing
                  email address can be removed from this field.
                </p>
                {errors.toMails.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <Row noGutters>
          <Col>
            <Form.Group controlId="exampleForm.ControlTextarea1">
              <Form.Label>CC</Form.Label>
              <Form.Control
                rows="3"
                type="text"
                data-title="ccMails"
                value={ccMails}
                disabled={disabled}
                onChange={onChange}
                onBlur={onBlur}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row noGutters>
          <Col>
            <Form.Group controlId="exampleForm.ControlTextarea1">
              <Form.Label>
                SUBJECT <span className="required">*</span>
              </Form.Label>
              <Form.Control
                rows="3"
                type="text"
                data-title="subject"
                value={subject}
                disabled={disabled}
                onChange={onChange}
                onBlur={onBlur}
                isInvalid={!!errors.subject.error}
              />
              <Form.Control.Feedback type="invalid">
                {errors.subject.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <Row noGutters>
          <Col>
            <Form.Group controlId="exampleForm.ControlTextarea1">
              <Form.Label>MESSAGE </Form.Label>
              <InfoIcon
                containerClass="email-tooltip2"
                Template={
                  customNotificationType === "PROJECT" ? (
                    <ProjectMessageTemplate />
                  ) : customNotificationType === "ISSUE" ||
                    customNotificationType === "AGENDA" ? (
                    <IssueMessageTemplate />
                  ) : null
                }
              />
              {/* <Form.Control
                rows="3"
                as="textarea"
                value={message}
                disabled={disabled}
                data-title="message"
                onChange={onChange}
              /> */}
              {/* <div className="email_editor">
                <CKEditor
                  editor={Editor}
                  //config={editorConfiguration}
                  data={this.state.message}
                  onChange={(event, editor) => {
                    //const editorData = editor.getData();
                    const editorData = DOMPurify.sanitize(editor.getData(), {
                      ALLOWED_TAGS: [
                        "b",
                        "i",
                        "u",
                        "p",
                        "br",
                        "strong",
                        "em",
                        "a"
                      ],
                      ALLOW_ID: true,
                      ALLOW_CLASS: true
                    });
                    this.setState({ message: editorData });
                  }}
                />
              </div> */}
              <div className="email_editor">
                <ReactQuill
                  value={this.state.message}
                  onChange={(html, event) => this.handleChange(html, event)}
                  theme="snow"
                  modules={toolbarConfig}
                  formats={formats}
                  bounds={".app"}
                  placeholder={"Write something..."}
                  ref={el => {
                    this.reactQuillRef = el;
                  }}
                />
              </div>

              {
                // message && htmlToFormattedText(message).length ? (
                //   <span className="message-count">
                //     {htmlToFormattedText(message).length}
                //   </span>
                // ) : (
                //   <React.Fragment />
                // )
              }
            </Form.Group>
          </Col>
        </Row>
        <Form.Group>
          {Object.keys(responseFromUploadApi).length !== 0 ? (
            <>
              <div className="d-flex flex-wrap">
                {attachedFileId.map((files, index) => (
                  <div className="email-attchmennts">
                    <div className="uploaded-file-wrapper">
                      <div className="uploaded-file">
                        <div
                          className="remove-file"
                          onClick={() => {
                            this.removeFileAttachment(
                              responseFromUploadApi.data,
                              index
                            );
                          }}
                        />
                        <div className="file-detail">
                          <div className="upload-icon">
                            {files[0].data.name.substr(
                              files[0].data.name.lastIndexOf(".") + 1,
                              files[0].data.name.length
                            )}
                          </div>
                          <div className="link-for-attachments ml-1">
                            <div className="link">
                              <a
                                className="ml-0"
                                href={files[0].data.s3Url}
                                target="_blank"
                              >
                                {files[0].data.name}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <></>
          )}
          <Files
            className="add-file"
            onChange={onAttachment}
            multiple={false}
            accepts={DOCUMENT_FORMATS}
            maxFileSize={26214400}
            minFileSize={0}
            clickable
          >
            <div className="add-attachment-button email-attachment-button">
              <Image
                src={IconPin}
                alt="Attachment Icon"
                className="add-attachment-img"
              />
              <span className="add-attachment-text">Add Attachment</span>
            </div>
          </Files>
          <div className="add-attachment-message">
            Max File Size:<b>10MB</b> | Supported File Formats:{" "}
            <b>{DOCUMENT_FORMATS.join(" ")}</b>
          </div>
        </Form.Group>
        <div class="send-btn">
          <Button size="sm" disabled={disabled} onClick={onSubmit}>
            Send
          </Button>
        </div>
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      removeFileDispatch: removeFileAction
    },
    dispatch
  );
}
export default connect(
  null,
  mapDispatchToProps
)(Template);
